export interface SliderWindow { centre: number; half: number }

const GROW_LIMIT = 5;

// The span a position slider shows for a value set from outside it (typed,
// Gather). A value a few spans out widens it around the original position, so
// the slider's centre still means "where the file was"; one far beyond it (a
// Gather across a CRS offset) re-centres it on the value instead.
export const freeWindow = (value: number, half: number): SliderWindow => {
  const size = Math.abs(value);
  if (size <= half) return { centre: 0, half };
  if (size <= half * GROW_LIMIT) return { centre: 0, half: Math.ceil(size * 1.25) };
  return { centre: value, half };
};

// The range input snaps to steps from its min, which can land a hair past an
// end; that must not count as leaving the span, or the span jumps mid-drag.
export const inWindow = (value: number, w: SliderWindow): boolean => {
  const eps = w.half * 1e-6;
  return value >= w.centre - w.half - eps && value <= w.centre + w.half + eps;
};
